import { Calendar, Clock } from 'lucide-react'
import type { RequestType } from '../types/hrmsAttendanceLeave.types'

interface RequestTypeChipProps {
  requestType: RequestType
}

export function RequestTypeChip({ requestType }: RequestTypeChipProps) {
  const norm = String(requestType || '').toUpperCase().replace(/[\s-]/g, '_')
  if (norm.includes('LEAVE')) {
    return (
      <span className="inline-flex items-center gap-1.5 rounded-full bg-teal-50 px-2.5 py-1 text-xs font-semibold text-teal-800 border border-teal-200">
        <Calendar className="h-3.5 w-3.5 text-teal-600" />
        Leave Request
      </span>
    )
  }

  return (
    <span className="inline-flex items-center gap-1.5 rounded-full bg-blue-50 px-2.5 py-1 text-xs font-semibold text-blue-800 border border-blue-200">
      <Clock className="h-3.5 w-3.5 text-blue-600" />
      Regularization
    </span>
  )
}
